import { createRouter, createWebHistory } from 'vue-router'
import { regelgruppenBeforeEnter } from './regelgruppenBeforeEnter'
import { keycloakBeforeEnter } from '@/router/keycloakBeforeEnter'

export const linkActiveClass = 'active-route'
export const linkExactActiveClass = 'active-route exact-active-route'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/einsendertypen',
      name: 'Einsendertypen',
      component: () => import('@/views/einsendertypen/EinsendertypenView.vue')
    },
    {
      path: '/regelgruppen',
      name: 'Regelgruppe',
      component: () => import('@/views/regelgruppen/RegelgruppenMain.vue')
    },
    {
      path: '/regelgruppen/:regelgruppenId?',
      name: 'Regelgruppen',
      component: () => import('@/views/regelgruppen/RegelgruppenMain.vue'),
      beforeEnter: [keycloakBeforeEnter, regelgruppenBeforeEnter]
    },
    {
      path: '/regelgruppen/:regelgruppenId?/patientenprofil/:patientenProfilId?',
      name: 'PatientenProfilePage',
      component: () => import('@/views/regelgruppen/RegelgruppenMain.vue'),
      beforeEnter: [keycloakBeforeEnter, regelgruppenBeforeEnter]
    },
    {
      path: '/regelgruppen/:regelgruppenId?/patientenprofil/:patientenProfilId?/regeln/:regelId?',
      name: 'RegelnPage',
      component: () => import('@/views/regelgruppen/RegelgruppenMain.vue'),
      beforeEnter: [keycloakBeforeEnter, regelgruppenBeforeEnter]
    },
    {
      path: '/analysen',
      name: 'Analysen',
      component: () => import('@/views/analysen/AnalysenView.vue')
    },
    {
      path: '/antibiotika',
      name: 'Antibiotika',
      component: () => import('@/views/antibiotika/AntibiotikaView.vue')
    },
    {
      path: '/resistenzmuster',
      name: 'Resistenzmuster',
      component: () => import('@/views/resistenzmuster/ResistenzmusterView.vue')
    },
    {
      path: '/keime',
      name: 'Keime',
      component: () => import('@/views/keime/KeimeView.vue')
    },
    {
      path: '/kundengruppen',
      name: 'kundengruppen',
      component: () => import('@/views/kundengruppen/KundengruppenView.vue')
    },
    {
      path: '/probengueter',
      name: 'Probengueter',
      component: () => import('@/views/probengueter/ProbengueterView.vue')
    },
    {
      path: '/layout-elemente',
      name: 'LayoutElemente',
      component: () => import('@/views/layoutElemente/LayoutElementeView.vue')
    },
    {
      path: '/textbausteine',
      name: 'Textbausteine',
      component: () => import('@/views/Textbausteine/TextbausteineView.vue')
    },
    {
      path: '/gueltigkeiten',
      name: 'gueltigkeiten',
      component: () => import('@/views/gueltigkeiten/GueltigkeitenView.vue')
    },
    {
      path: '/keimgruppen',
      name: 'keimgruppen',
      component: () => import('@/views/keimgruppen/KeimgruppenView.vue')
    },
    {
      path: '/',
      redirect: '/regelgruppen'
    }
  ],
  linkActiveClass,
  linkExactActiveClass
})

export default router
